module.exports = __webpack_public_path__ + "karit_logo.3263238acdf2af4b1ef95894a8fdc949.png";